import axios from "axios";

const DEFAULT_CONF = {};

const OQFeedbackApi = {
  requestPhoneCode(phone) {
    return axios
      .post(
        process.env.VUE_APP_OQ_FEEDBACK_API + "/confirm_phone",
        { phone },
        DEFAULT_CONF
      )
      .then((r) => {
        return r.data.phone_id;
      })
      .catch(() => undefined);
  },
  checkPhoneCode(phone_id, code) {
    return axios
      .post(
        process.env.VUE_APP_OQ_FEEDBACK_API + "/check_phone_code",
        { phone_id, code },
        DEFAULT_CONF
      )
      .then((r) => {
        return { status: r.data.status, error: r.data.error };
      })
      .catch(() => undefined);
  },
  sendForm(
    fio,
    phone,
    phone_id,
    comment,
    agreement,
    files,
    form_type = "corp",
    payload = {}
  ) {
    return axios
      .post(
        process.env.VUE_APP_OQ_FEEDBACK_API + "/send_form",
        {
          fio,
          phone,
          phone_id,
          comment,
          agreement,
          files: files?.filter((f) => !f.error && !f.progress),
          form_type,
          payload,
        },
        DEFAULT_CONF
      )
      .then((r) => {
        return r.data;
      })
      .catch(() => false);
  },
};

export default OQFeedbackApi;
